"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var EmbedIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 31 19", fill: "currentColor", width: size || '31', height: size || '19' }, props),
        React.createElement("path", { id: "a", fill: "currentColor", d: "M21.4,15.3c-0.4-0.4-0.4-1,0-1.4c0,0,0.1-0.1,0.1-0.1l5.1-4.1l-5.1-4c-0.4-0.3-0.5-1-0.2-1.4 c0,0,0,0,0.1-0.1L22,3.6c0.4-0.4,1-0.4,1.4-0.1L31,9.8L23.3,16c-0.4,0.3-1,0.3-1.3-0.1L21.4,15.3L21.4,15.3z M9.7,15.3L9,15.9 c-0.4,0.4-1,0.4-1.4,0.1L0,9.8l7.6-6.3C8,3.2,8.6,3.2,9,3.6l0.7,0.8c0.4,0.4,0.3,1-0.1,1.4c0,0,0,0-0.1,0L4.5,9.8l5.1,4 C10,14.1,10.1,14.7,9.7,15.3C9.7,15.2,9.7,15.2,9.7,15.3L9.7,15.3z M13.3,18.9l-0.9-0.3c-0.5-0.2-0.8-0.7-0.6-1.2l5.1-16.7 C17,0.2,17.6-0.1,18.1,0c0,0,0,0,0,0l0.9,0.3c0.5,0.2,0.8,0.7,0.6,1.2l-5.1,16.7C14.4,18.8,13.8,19.1,13.3,18.9 C13.3,19,13.3,18.9,13.3,18.9z" })));
};
EmbedIcon.displayName = 'EmbedIcon';
exports.default = EmbedIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmbedIcon.js.map